import { useCookies } from "react-cookie";
import { Dashboard } from "../enums/Dashboard";


export enum Cookie {

    BatteryLevelEvents = 'selected_battery_events',
    IotDeviceEvents = 'selected_iot_device_events',
    IotGatewayEvents = 'selected_iot_gateway_events',

    BatteryLevelVillage = 'selected_village_battery',
    IotDeviceVillage = 'selected_village_iot_device',
    IotGatewayVillage = 'selected_village_iot_gateway',
    WiFiVillage = 'selected_village_wifi'
    // SpokeVillage = 'selected_village_spoke'
    


};



export const useVspPortalCookies = ( ): { 

    getEventsCookies( dashboard: Dashboard ): string[ ] | null    
    , getVillageCookies( dashboard: Dashboard ): string | null
    , removeDashboardCookies( dashboard: Dashboard ): void
    , setDashboardCookies( dashboard: Dashboard, events: string[ ], village: string ): void

} => {

    const [ cookies, setCookie, removeCookie ] = useCookies( );


    const getEventsCookies = ( dashboard: Dashboard ): string[] | null => {
    
        switch( dashboard ) {

            case Dashboard.BatteryLevel:
                return cookies[ Cookie.BatteryLevelEvents ];
            
            case Dashboard.IotDevice:
                return cookies[ Cookie.IotDeviceEvents ];

            case Dashboard.IotGateway:
                return cookies[ Cookie.IotGatewayEvents ];

        }

        return null;
    
    };


    const getVillageCookies = ( dashboard: Dashboard ): string | null => {

        switch( dashboard ) {

            case Dashboard.BatteryLevel:
                return cookies[ Cookie.BatteryLevelVillage ];
            
            case Dashboard.IotDevice:
                return cookies[ Cookie.IotDeviceVillage ];

            case Dashboard.IotGateway:
                return cookies[ Cookie.IotGatewayVillage ];

        }

        return null;

    };


    const removeDashboardCookies = ( dashboard: Dashboard ): void => {

        switch( dashboard ) {

            case Dashboard.BatteryLevel:
                removeCookie( Cookie.BatteryLevelVillage );
                removeCookie( Cookie.BatteryLevelEvents );
                return;
            
            case Dashboard.IotDevice:
                removeCookie( Cookie.IotDeviceVillage );
                removeCookie( Cookie.IotDeviceEvents );
                return;

            case Dashboard.IotGateway:
                removeCookie( Cookie.IotGatewayVillage );
                removeCookie( Cookie.IotGatewayEvents );
                return;

        }

    };


    const setDashboardCookies = ( dashboard: Dashboard, events: string[ ], village: string ): void => {

        switch( dashboard ) {

            case Dashboard.BatteryLevel:
                setCookie( Cookie.BatteryLevelVillage, village );
                setCookie( Cookie.BatteryLevelEvents, JSON.stringify( events ) );
                return;
            
            case Dashboard.IotDevice:
                setCookie( Cookie.IotDeviceVillage, village );
                setCookie( Cookie.IotDeviceEvents, JSON.stringify( events ) );
                return;

            case Dashboard.IotGateway:
                setCookie( Cookie.IotGatewayVillage, village );
                setCookie( Cookie.IotGatewayEvents, JSON.stringify( events ) );
                return;

        }

    };

    
    return {
        
        getEventsCookies
        , getVillageCookies
        , removeDashboardCookies
        , setDashboardCookies

    };
    
};